// Carousel
let currentSlide = 0;
const track = document.getElementById('carouselTrack');
const dots = document.querySelectorAll('.dot');

function goSlide(n) {
    if (!track) return;
    currentSlide = n;
    track.style.transform = `translateX(-${n * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === n));
}

if (track) {
    setInterval(() => {
        currentSlide = (currentSlide + 1) % 3;
        goSlide(currentSlide);
    }, 5000);

    document.querySelector('.carousel-dots')?.addEventListener('click', function(e) {
        const dot = e.target.closest('[data-slide]');
        if (dot) goSlide(parseInt(dot.dataset.slide, 10));
    });
}

// Ensure nav height is available as a CSS variable and body is offset to avoid content jump
function updateNavHeight(){
    const nav = document.querySelector('.nav');
    if (nav) {
        document.documentElement.style.setProperty('--nav-height', nav.offsetHeight + 'px');
    }
}
window.addEventListener('load', updateNavHeight);
window.addEventListener('resize', updateNavHeight);

// Smooth scroll with offset for fixed header
document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
        const selector = this.getAttribute('href');
        const t = document.querySelector(selector);
        if (t) {
            e.preventDefault();
            const nav = document.querySelector('.nav');
            const offset = nav ? nav.offsetHeight : 0;
            const top = t.getBoundingClientRect().top + window.pageYOffset - offset - 10;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    });
});

// Add to Cart handler — adds item then opens cart drawer
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.js-add-to-cart');
    if (!btn) return;

    const variantId = parseInt(btn.dataset.variantId, 10);
    const wrap = btn.closest('.buy-button-wrap');
    const diag = wrap ? wrap.querySelector('.buy-diagnostic') : null;

    if (!variantId) {
        if (diag) { diag.textContent = 'Product not configured. Please check theme settings.'; diag.style.display = 'block'; }
        return;
    }

    const origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    if (diag) diag.style.display = 'none';

    fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) {
        if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Could not add to cart'); });
        return r.json();
    })
    .then(function() {
        btn.disabled = false;
        btn.textContent = origText;
        // Open cart drawer
        if (window.CartDrawer) {
            window.CartDrawer.open();
        }
    })
    .catch(function(err) {
        btn.disabled = false;
        btn.textContent = origText;
        const msg = err.message || 'Could not add item to cart. Please try again.';
        if (diag) { diag.textContent = msg; diag.style.display = 'block'; }
        else alert(msg);
    });
});

// Scroll animations
const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
        if (e.isIntersecting) {
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
        }
    });
}, { threshold: 0.1 });

document.querySelectorAll('.feat-card,.product-card,.test-card,.step,.spec-item,.trust-item,.food-item,.p-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity .5s,transform .5s';
    observer.observe(el);
});

// Mobile drawer
(function() {
    var btn = document.getElementById('mobileMenuBtn');
    var drawer = document.getElementById('mobileDrawer');
    var overlay = document.getElementById('mobileOverlay');
    var close = document.getElementById('mobileCloseBtn');
    if (!btn || !drawer || !overlay) return;

    function openDrawer() {
        drawer.classList.add('active');
        overlay.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
        drawer.classList.remove('active');
        overlay.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }
    btn.addEventListener('click', openDrawer);
    if (close) close.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
})();

// Nav scroll shadow
(function() {
    var nav = document.getElementById('siteNav');
    if (!nav) return;
    window.addEventListener('scroll', function() {
        nav.classList.toggle('scrolled', window.scrollY > 10);
    });
})();

// Active nav link based on current URL
(function() {
    var path = window.location.pathname;
    var links = document.querySelectorAll('.nav-links a, .mobile-nav-links a');
    links.forEach(function(link) {
        var href = link.getAttribute('href');
        if (!href) return;
        // Exact match for collection pages
        if (path === '/collections/frontpage' && href === '/collections/frontpage') {
            link.classList.add('active');
        }
        // Match for track-order
        if (path === '/pages/track-order' && href === '/pages/track-order') {
            link.classList.add('active');
        }
    });
})();
